<!--
    校区管理-学生管理
    功能：展示学生列表数据、信息编辑、上课统计、班级加入、绑定手机号、游戏练习、作业下发
    组件:AppList、AppSearch、AppUploadScale
-->
<template>
  <div class="student_list">
    <!--
      excelLabel="批量导入"
      downloadLabel="导出模板"-->
    <AppList
      ref="list"
      :list.sync="list"
      :create-label="$permissions('school_student_list_add') ? '新增学生' : ''"
      title=""
      api="/api/student"
      @create="toCreate"
      @excelPage="excelExport"
      @downloadPage="downloadTemplate">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <div
        v-if="lock_student"
        slot="after"
        class="search-after"
      >
        {{ lock_student }}个学生作业练习已锁, <a @click="aKeyToUnlock">一键解锁</a>
      </div>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            width="80px"
            label="头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.headimgurl ? scope.row.headimgurl : ''"
                :onerror="scope.row.gender === 1 ? moveErrorBoy : moveErrorGirl"
                class="head_url"
                alt="">
            </template>
          </el-table-column>
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="330px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <template v-if="$store.state.from === 'schoolCenter'">
                <el-link
                  v-if="$permissions('school_student_list_edit')"
                  size="small"
                  @click="edit(scope.row)"
                >编辑</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  v-if="$permissions('school_student_list_classes')"
                  size="small"
                  @click="StudentClass(scope.row)"
                >班级</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  v-if="$permissions('school_student_list_statistics')"
                  size="small"
                  plain
                  @click="Statistics(scope.row)"
                >上课统计</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  size="small"
                  plain
                  @click="bindPhone(scope.row)"
                >重新绑定手机</el-link>
              </template>
              <template v-else>
                <el-button
                  v-if="$permissions('school_student_list_edit')"
                  size="small"
                  @click="edit(scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="$permissions('school_student_list_classes')"
                  size="small"
                  @click="StudentClass(scope.row)"
                >班级</el-button>
                <el-button
                  v-if="$permissions('school_student_list_statistics')"
                  size="small"
                  plain
                  @click="Statistics(scope.row)"
                >上课统计</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      :title="dialogTitle === 'add' ? '新增学生': '修改学生'"
      :visible.sync="formDialogVisible"
      width="1000px">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="125px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="学生名称："
              prop="name">
              <el-input
                v-model="formData.name"
                placeholder="请输入真实姓名"/>
            </el-form-item>
            <el-form-item
              label="联系电话："
              prop="mobile">
              <el-input
                :disabled="dialogTitle === 'edit'"
                v-model="formData.mobile"
                placeholder="请输入联系电话"/>
            </el-form-item>
            <el-form-item label="年级：">
              <el-select
                v-if="grade"
                v-model="formData.grade"
                placeholder="请选择年级">
                <el-option
                  v-for="item in grade"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="dialogTitle === 'add'"
              label="性别：">
              <el-radio
                v-model="formData.gender"
                :label="1">男</el-radio>
              <el-radio
                v-model="formData.gender"
                :label="2">女</el-radio>
            </el-form-item>
          </el-col>
          <el-col
            v-if="dialogTitle !== 'add'"
            :span="12">
            <el-form-item
              label="真实头像："
              class="headimgurl">
              <!-- <img
                :src="formData.headimgurl ? formData.headimgurl : ''"
                :onerror="formData.gender === 1 ? moveErrorBoy : moveErrorGirl"
                class="form_img"
                alt=""> -->
              <AppUploadScale
                v-model="formData.headimgurl"
                class="form_img"
                @on-success="getThumbnailrUrl" />
            </el-form-item>
            <el-form-item label="性别：">
              <el-radio
                v-model="formData.gender"
                :label="1">男</el-radio>
              <el-radio
                v-model="formData.gender"
                :label="2">女</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="formDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitStaff">确 定</el-button>
      </span>
    </el-dialog>

    <!--    作业下发确认-->
    <el-dialog
      v-if="dialogIssue.show"
      :visible.sync="dialogIssue.show"
      class="dialog-game dialog-sp1"
      title="解锁/开通作业练习权限"
      width="1000px"
    >
      <div style="line-height: 50px;margin-top: -30px;">
        以下学生作业练习权限已锁, 对方将收不到作业
      </div>
      <el-table
        v-loading.lock="dialogIssue.loading"
        :data="dialogIssue.data"
        row-key="id"
        @selection-change="gameIssueSelect"
      >
        <el-table-column
          type="selection"
          width="54"
          reserve-selection
        />

        <el-table-column
          label="序号"
        >
          <template slot-scope="scope">
            <p v-html="scope.row.index"/>
          </template>
        </el-table-column>

        <el-table-column
          v-for="(item, index) in dialogIssue.tableHead"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :formatter="item.formatter"
        />

        <el-table-column
          label="作业练习权限"
        >
          <template slot-scope="scope">
            <p v-html="scope.row.qx"/>
          </template>
        </el-table-column>

        <div
          slot="empty"
          class="data-empty">
          <el-image :src="$assets.empty"/>
          <p>暂无数据</p>
        </div>
      </el-table>

      <el-pagination
        v-if="dialogIssue.data.length && dialogIssue.meta"
        :page-size="10"
        :current-page="dialogIssue.meta.current_page"
        :total="dialogIssue.meta.total"
        background
        layout="prev, pager, next"
        @current-change="gameIssue"
      />

      <div
        slot="footer"
        class="dialog-footer flex jc">
        <el-button
          size="small"
          type="primary"
          @click="taskIssueSubmit">确认解锁</el-button>
      </div>
    </el-dialog>

    <!--    确认并下发练习-->
    <el-dialog
      v-if="dialogIssuePay.show"
      :visible.sync="dialogIssuePay.show"
      class="dialog-game dialog-sp1"
      width="500px"
    >
      <div
        v-loading.lock="dialogIssuePay.loading"
        style="padding: 0 30px;"
      >
        <el-form :model="dialogIssuePay.forms">
          <el-form-item label="解锁学生数:">
            <span>{{ dialogIssuePay.forms.student }}</span>人
          </el-form-item>

          <el-form-item label="有效期选择:">
            <el-input-number
              v-model="dialogIssuePay.forms.month"
              :min="1"
              size="small"
              @change="dialogIssuePayChange"/> (月)
          </el-form-item>

          <el-form-item label="扣除金币数:">
            <span>{{ dialogIssuePay.forms.coin }}</span>金币
          </el-form-item>

          <el-form-item
            v-if="dialogIssuePay.forms.pay"
            label="扫码现金支付:">
            <span>{{ dialogIssuePay.forms.pay }}</span>元

            <el-button
              size="small"
              type="primary"
              style="float: right;margin-top: 4px;"
              @click="dialogIssuePayCover">去支付</el-button>
          </el-form-item>
        </el-form>

        <div
          v-if="dialogIssuePay.success"
          class="isuue-success"
        >
          <div style="text-align: center">
            <i class="el-icon-success"/>
            支付成功
          </div>
        </div>

        <div
          v-else
          slot="footer"
          class="dialog-footer flex jc">
          <el-button
            size="small"
            type="primary"
            style="margin: 0 auto;display: block;margin-top: 20px;"
            @click="dialogIssuePaySubmit">确认解锁</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 学生绑定新手机 -->
    <bind-phone-dialog
      v-if="bindPhoneDialog"
      :visible.sync="bindPhoneDialog"
      :cur-data="curData"
      @refresh-data="handleRefresh"
      @close-dialog="bindPhoneDialog = false"/>
  </div>
</template>

<script>
import list from '@/mixins/list';
import defaultBoy from '@/assets/images/student_boy.png';
import defaultGirl from '@/assets/images/student_girl.png';
import BindPhoneDialog from './components/BindPhoneDialog';

import baseUrl from '@/utils/api';

import {
  getPracticeIssueOrder, // 游戏练习 - 作业下发确认 解锁订单
  getPracticePaySuccess,
} from '@/api/practice';

export default {
  name: 'StudentList',
  inject: ['reload'],
  components: {
    BindPhoneDialog,
  },
  mixins: [list],
  data() {
    return {
      list: {},
      bindPhoneDialog: false, // 绑定手机弹窗
      curData: {},
      formDialogVisible: false,
      moveErrorBoy: `this.src="${defaultBoy}"`,
      moveErrorGirl: `this.src="${defaultGirl}"`,
      form: {
        name: '', // 姓名
        mobile: '', // 电话
        headimgurl: '', // 头像
        gender: 1, // 性别
        grade: 1, // 年级
      },
      formData: {},
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        mobile: [
          this.$rules.required('手机号'), { ...this.$rules.mobile },
        ],
      },
      dialogTitle: '',
      isCreated: true,

      dialogIssue: {
        show: false,
        loading: false,
        tableHead: [
          {
            prop: 'name',
            label: '学生名字',
          },
          {
            prop: 'number',
            label: '学号',
          },
          {
            label: '有效期',
            formatter: row => (row.exercise_expired && row.exercise_expired.exercise_expired_at ? row.exercise_expired.exercise_expired_at : '--'),
          },
        ],
        data: [],
        class_select: [],
      },

      dialogIssuePay: {
        show: false,
        loading: false,
        success: false,
        forms: {
          student: 0,
          month: 1,
          coin: 0,
          pay: 0,
        },
        code: '',
      },

      lock_student: 0,
    };
  },
  computed: {
    grade() {
      return this.$store.state.grade;
    },
    columns() {
      return [
        { prop: 'name', label: '学生名称' },
        {
          label: '性别',
          width: '80px',
          formatter: row => (row.gender === 1 ? '男' : '女'),
        },
        { prop: 'mobile', label: '手机号' },
        { label: '练习权限', formatter: row => (row.is_exercise_expired ? '已过期' : '进行中') },
        { prop: 'wechat_name', label: '微信昵称' },
        { prop: 'number', label: '学号' },
        { prop: 'grade_text', label: '年级' },
        { label: '有效期', width: '160px', formatter: row => (row.exercise_expired && row.exercise_expired.exercise_expired_at ? row.exercise_expired.exercise_expired_at : '--') },
        { prop: 'attend_count', label: '上课总次数' },
        { prop: 'created_at', label: '注册时间', width: '160px' },
      ];
    },
    searchArr() {
      const column = [
        { prop: 'name', label: '学生名称' },
        { prop: 'mobile', label: '手机号' },
      ];
      return [
        {
          selectValue: [
            { value: 1, name: '已过期' },
            { value: 0, name: '进行中' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'is_exercise_expired',
          placeholder: '请选择练习权限',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
  },
  created() {
    this.formData = this.form;

    this.gameIssue(1, true);
  },
  methods: {
    // 请求数据
    handleRefresh() {
      this.$refs.list.getList();
    },
    // 上课统计入口
    Statistics(row) {
      this.$router.push(`/student/statistics/${row.id}/${row.name}/${row.mobile}`);
    },
    // 我的班级入口
    StudentClass(row) {
      this.$router.push(`/student/class/${row.id}/${row.name}/${row.mobile}`);
    },
    // 新增学生按钮
    toCreate() {
      this.formDialogVisible = true;
      this.dialogTitle = 'add';
      this.formData = this.form;
    },
    // 编辑学生按钮
    edit(row) {
      this.formDialogVisible = true;
      this.formData = { ...row };
      if (!this.formData.headimgurl) {
        this.formData.headimgurl = this.formData.gender === 1 ? defaultBoy : defaultGirl;
      }
      this.dialogTitle = 'edit';
    },
    // 上传图片
    getThumbnailrUrl(url) {
      this.$nextTick(() => {
        this.formData.headimgurl = url;
      });
      this.$forceUpdate();
    },
    // 批量导入
    excelExport() {

    },
    // 下载模板
    downloadTemplate() {

    },
    // 提交新增学生
    submitStaff() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isCreated) {
            if (this.dialogTitle === 'add') {
              // 新增
              this.isCreated = false;
              this.$http.post('/api/student', this.formData)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('保存成功');
                  this.formDialogVisible = false;
                  this.reload();
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            } else {
              // 修改
              this.isCreated = false;
              this.$http.put(`/api/student/${this.formData.id}`, this.formData)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('保存成功');
                  this.formDialogVisible = false;
                  this.reload();
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 一键解锁
    aKeyToUnlock() {
      this.dialogIssue.selectIds = [];
      this.gameIssue();
    },

    // 游戏练习 - 作业下发确认
    gameIssue(page = 1, lock = false) {
      this.dialogIssue.show = !lock;
      this.dialogIssue.loading = true;

      this.$http.get(`/api/student?equal[is_exercise_expired]=1&page=${page}`).then((res) => {
        if (lock) {
          this.lock_student = res.meta.total;
        } else {
          res.items.forEach((val, key) => {
            val.index = key + 10 * page - 9;
            val.qx = '已锁';
          });

          this.dialogIssue.data = res.items;
          this.dialogIssue.meta = res.meta;
        }
      }).finally(() => {
        this.dialogIssue.loading = false;
      });
    },

    // 游戏练习 - 作业下发确认 多选
    gameIssueSelect(arr) {
      const arr_a = [];

      arr.forEach((val) => {
        if (!Array.isArray(val.student)) {
          arr_a.push(val);
        }
      });

      this.dialogIssue.class_select = arr_a;
    },

    // 游戏练习 - 作业下发确认 解锁并发布
    taskIssueSubmit() {
      if (!this.dialogIssue.class_select.length) {
        return;
      }

      this.dialogIssuePayShow();
    },

    // 游戏练习 - 作业下发确认 - 确认并下发练习
    dialogIssuePayShow() {
      this.dialogIssuePay.success = false;
      this.dialogIssuePay.forms.pay = 0;
      this.dialogIssuePay.forms.month = 1;
      this.dialogIssuePay.forms.student = this.dialogIssue.class_select.length;

      this.dialogIssuePay.show = true;
      this.dialogIssuePay.loading = true;

      this.$http.get(`${baseUrl}/api/student/exercise/price?clients_id=${this.$store.state.choicesSchool.id}`).then((res) => {
        this.dialogIssuePay.forms.coinInit = res.data.price;
        this.dialogIssuePay.forms.coin = (1e4 * this.dialogIssuePay.forms.student * res.data.price) / 1e4;
      }).finally(() => {
        this.dialogIssuePay.loading = false;
      });
    },

    // 游戏练习 - 作业下发确认 - 确认并下发练习 月
    dialogIssuePayChange() {
      this.dialogIssuePay.forms.coin = (1e4 * this.dialogIssuePay.forms.student * this.dialogIssuePay.forms.month * this.dialogIssuePay.forms.coinInit) / 1e4;
      this.dialogIssuePay.forms.pay = 0;
    },

    // 游戏练习 - 作业下发确认 - 确认并下发练习 去支付
    dialogIssuePayCover() {
      window.open(this.dialogIssuePay.code);
    },

    // 游戏练习 - 作业下发确认 - 确认并下发练习 确认
    dialogIssuePaySubmit() {
      if (this.dialogIssuePay.success) {
        this.dialogIssuePay.show = false;
      } else if (this.dialogIssuePay.forms.pay) {
        this.dialogIssuePay.loading = true;

        getPracticePaySuccess({
          id: this.dialogIssuePay.forms.orderId,
        }).then((res) => {
          if (res.data.status === 2) {
            this.dialogIssuePay.success = true;
            this.$message.success('支付成功');

            setTimeout(() => {
              this.dialogIssue.show = false;
              this.dialogIssuePay.show = false;
            }, 1e3);
          } else {
            this.$message.warning('还未检测到是否支付成功, 请稍后重试');
          }
        }).finally(() => {
          this.dialogIssuePay.loading = false;
        });
      } else {
        this.dialogIssuePay.loading = true;

        this.$http.post('api/student/exercise/orders', {
          customize_ids: this.dialogIssue.selectIds,
          months: this.dialogIssuePay.forms.month,
          student_ids: this.dialogIssue.class_select.map(val => val.id),
        }).then((res) => {
          getPracticeIssueOrder({
            id: res.data.id,
          }).then((res1) => {
            const data1 = res1.data;

            this.dialogIssuePay.forms.orderId = data1.id;

            if (data1.cash_should_pay) {
              this.dialogIssuePay.code = data1.recharge.code_img_url;
              this.dialogIssuePay.forms.coin = data1.coin_paid;
              this.dialogIssuePay.forms.pay = data1.cash_should_pay;
              this.$message.warning('金币不足, 请点击"去支付"');
            } else {
              this.dialogIssuePay.success = true;
              this.$message.success('支付成功');

              setTimeout(() => {
                this.dialogIssue.show = false;
                this.dialogIssuePay.show = false;
                this.reload();
              }, 1e3);
            }

            this.dialogIssuePay.loading = false;
          }).catch(() => {
            this.dialogIssuePay.loading = false;
          });
        }).catch(() => {
          this.dialogIssuePay.loading = false;
        });
      }
    },
    // 绑定手机弹窗
    bindPhone(row) {
      this.curData = Object.assign({}, row);
      this.bindPhoneDialog = true;
    },
  },
};
</script>

<style scoped lang="scss">
  .isuue-success {
    display: flex;
    justify-content: center;

    i {
      display: block;
      font-size: 60px;
      color: #FAAD14;
    }
  }

  .student_list {
    .form_img {
      width: 100px;
      height: 100px;
      display: block;
    }
    .headimgurl {
      margin-bottom: 9px;
    }
    .el-radio {
      margin-right: 5px;
    }
    .el-icon-question {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      font-size: 18px;
      color: var(--color-primary);
    }
    .el-select {
      width: 100%;
    }
    .head_url {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
  .search-after {
    padding-bottom: 20px;

    a {
      color: #FAAD14;
      cursor: default;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Student/index.vue